import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from '@/app/core/config/app.config';
import { App } from '@/app/core/initializer/app';

import '@fontsource-variable/inter-tight/wght.css';
import '@fontsource-variable/manrope/wght.css';

bootstrapApplication(App, appConfig)
  .catch((err) => console.error(err));
